// extracted by mini-css-extract-plugin
module.exports = {"textArea":"textArea_textArea__2rpdO","fill":"textArea_fill__2bvah","noResize":"textArea_noResize__UGAse"};